import { html } from "../../base/_utils";

export default function execStaffCard(member, path) {
    return html`
        <div class="card h-100 border-0 text-center">
            <div class="card-img-top">
                <img class="img-fluid w-100" src="${path}${member.image}" loading="lazy" alt="${member.name} headshot" />
            </div>
            <div class="card-body">
                <p class="mb-0"><strong>${member.name}</strong></p>
                <p><i>${member.title}</i></p>
            </div>
        </div>
    `;
}
